import * as React from "react";
import { Chip, ChipSize } from "../../../ui";
import { OrderPickupSummary, orderPickupLabel } from "../../partsStatus.utils";
import { chipStyle, stateColors } from "../partStatusChip.utils";

export const OrderStatusChip: React.FC<{ summary: OrderPickupSummary }> = ({ summary }) => {
  const label = orderPickupLabel(summary);

  return (
    <Chip
      size={ChipSize.SMALL}
      style={{ ...chipStyle, ...stateColors[summary.state] }}
      label={label}
      aria-label={`Order status: ${label}`}
    />
  );
};
